import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'

export const genericHeadingStyle = css`
  margin-top: 0;
  letter-spacing: -1px;
  color: ${Theme.colors.blue};
  font-size: 48px;
  ${Media.mobile`
    line-height: 40px;
    letter-spacing: -0.75px;
    max-width: 263px;
    font-size: 36px;
  `}
`

const Heading = styled.h1`
  ${genericHeadingStyle}
`

export default Heading
